import { Navigate } from "react-router";

export const USERS_SETTINGS_PATH = "/parametres/utilisateurs";

/**
 * Upstream /sales, /sales/create and /sales/:id are replaced by the
 * invite-only users screen (SalesCreate would bypass invitations).
 */
export const SalesToUsersRedirect = () => (
  <Navigate to={USERS_SETTINGS_PATH} replace />
);
